import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiService {
  constructor(public http: HttpClient) {}

  get(url: string, getParams?: any, responseType?: any) {
    return this.apiCallRepeater('get', url, getParams, responseType);
  }

  post(url: string, postBody: any, image?: any, options?: any) {
    return this.apiCallRepeater('post', url, postBody, 'json', image, options);
  }

  delete(url: string, deleteParams?: any) {
    return this.apiCallRepeater('delete', url, deleteParams);
  }

  put(url: string, putData: any) {
    return this.apiCallRepeater('put', url, putData);
  }

  patch(url: string, patchBody: any) {
    return this.apiCallRepeater('patch', url, patchBody);
  }

  upload(url: string, file: File, reportProgress = false, isAvatar = false) {
    let params = null;
    if (file) {
      params = isAvatar ? { attachment: file } : { files: file };
    }
    const options: any = {};
    if (reportProgress) {
      options.reportProgress = true;
      options.observe = 'events';
    }
    return this.http.post<any>(url, this.toFormData(params), options);
  }

  uploadReference(url: string, file: File, data: any) {
    let descriptions = [];
    if ('descriptions' in data) {
      descriptions = data.descriptions;
      delete data.descriptions;
    }

    const formData = this.toFormData(data);
    Object.keys(formData).forEach((key) => {
      formData[key] = '' + formData[key];
    });

    if (descriptions?.length) {
      if (Array.isArray(descriptions)) {
        for (let i = 0; i < descriptions.length; i++) {
          Object.keys(descriptions[i]).forEach((key) => {
            formData.append(
              `descriptions[${i}][${key}]`,
              '' + descriptions[i][key],
            );
          });
        }
      }
    }

    if (file) {
      formData.append('attachment', file, file.name);
    }

    return this.http.post<any>(url, formData);
  }

  private apiCallRepeater(
    type: string,
    url: string,
    data?: any,
    responseType?: 'json',
    image?: any,
    options?: any,
  ) {
    const params = data ? structuredClone(data) : null;
    switch (type) {
      case 'get':
        return this.http.get<any>(url, {
          params: this.parseParams(params),
          responseType,
        });
      case 'post':
        if (image) {
          return this.http.post<any>(url, this.toFormData(params), options);
        } else {
          return this.http.post<any>(url, params);
        }
      case 'delete':
        return data
          ? this.http.delete<any>(`${url}/${data}`)
          : this.http.delete<any>(url);
      case 'put':
        return this.http.put<any>(url, params);
      case 'patch':
        return this.http.patch<any>(url, params);
    }
  }

  private parseParams(params: any) {
    if (!Object.entries)
      Object.entries = function (obj) {
        let ownProps = Object.keys(obj),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array
        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
      };

    if (params) {
      Object.entries(params).forEach(([key]) => {
        if (typeof params[key] === 'object') {
          Object.defineProperty(
            params,
            key + '[]',
            Object.getOwnPropertyDescriptor(params, key),
          );
          delete params[key];
        }
      });
    }
    return params;
  }

  toFormData(formValue) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          formData.append(key + `[${i}]`, value[i]);
        }
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  }
}
